// extracted by mini-css-extract-plugin
module.exports = {"WidgetsItemQuestionnaire":"widgets-item-questionnaire_WidgetsItemQuestionnaire__dcHXt"};